<p-dialog header="View Charts" [(visible)]="displayDialog" [closable]="true" (onHide)="closeDialog()" [modal]="true" [style]="{width: '75vw'}" appendTo="body" [focusOnShow]="false">
    <div class="p-grid">
        <div *ngIf="dynamicCharts?.length==0" class="p-col-12">
            <div class="add-block">
                <div class="p-text-center">
                    <p>No Charts Added Yet!</p>
                    <button pButton label="Add New Chart" (click)="showAddCharts()"></button>
                </div>
            </div>
        </div>
        <div *ngIf="dynamicCharts?.length>0" class="p-col-12">
            <div class="tab-wrapper">
                <p-menu #configmenu id="config_menu" [model]="contextMenuItems" [popup]="true" appendTo="body"></p-menu>
                <div class="tab-rightmenu-wrapper">
                    <div class="p-d-flex p-ai-center">
                        <app-filters [listCols]="mappedColFilter"
                            (applyFiltersColumns)="applyFilters($event)"
                            [saveFilterData]="saveFilterData"
                            [isWorkspaceModule]="true">
                        </app-filters>

                        <div class="btnBars">
                            <i class="pi pi-bars" (click)="configmenu.toggle($event)"></i>
                        </div>
                        <div class="btnBars">
                            <i class="pi pi-plus" (click)="showAddCharts()"></i>
                        </div>
                    </div>
                </div>
                <p-tabView (onChange)="changeTab($event)" [(activeIndex)]="selectedTabIndex" class="custom-tablist custom-tablist-button tab-rightmenu" [scrollable]="true">
                    <!---- Dynamic Tab List -------->
                    <ng-container *ngFor="let dynamicChart of dynamicCharts; let i = index">
                        <p-tabPanel>
                            <ng-template pTemplate="header">
                                <div (click)="selectSubTab(i)" class="p-d-flex p-ai-center custom-tab-name">
                                    <span style="white-space: nowrap;">{{ dynamicChart?.title }}</span>
                                </div>
                            </ng-template>
                            <div class="chart-container">
                                <app-workbook-dynamic-bar-chart *ngIf="selectedTabIndex==i"
                                    [dynamicChart]="dynamicChart"
                                    [workbookId]="workbookId"
                                    [allListColumns]="allListColumns"
                                    [filterInColumns]="filterInColumns"
                                    [isChartDataLoading]="isChartDataLoading"
                                    (onDataLoading)="onDataLoading($event)">
                                </app-workbook-dynamic-bar-chart>
                            </div>
                        </p-tabPanel>
                    </ng-container>
                    <!---- Dynamic Tab List End --->
                </p-tabView>
            </div>
        </div>
    </div>
</p-dialog>

<app-workbook-dynamic-charts-add *ngIf="displayAddCharts" [displayDialog]="displayAddCharts"
    [workbookId]="workbookId"
    [allListColumns]="allListColumns"
    [selectedChartWidget]="selectedChartWidget"
    (onAddNew)="onAddNewChart($event)"
    (onDialogClosed)="closeAddCharts()">
</app-workbook-dynamic-charts-add>
<p-confirmDialog key="dynamicChart" [style]="{ width: '20vw' }" [baseZIndex]="1000000"/>
